const WATER_TANKER = {
  length: 9.1,
  bodyWidth: 2.55,
  wheelRadius: 0.62,
  tyreWidth: 0.4,
  dualSpacing: 0.36,
  axles: [
    { fitment: 'single', x: 2.75, halfTrack: 1.04 },
    { fitment: 'dual', x: -1.2, halfTrack: 0.94 },
    { fitment: 'dual', x: -2.75, halfTrack: 0.94 },
  ],
  tank: {
    centreX: -0.72,
    centreY: 2.02,
    radius: 1.2,
    length: 4.85,
  },
};

export { WATER_TANKER };
